var toString = Object.prototype.toString

module.exports = isString

function isString(obj) {
    return toString.call(obj) === "[object String]"
}



//////////////////
// WEBPACK FOOTER
// ./~/x-is-string/index.js
// module id = 1679
// module chunks = 0